import React, { useState } from 'react';
import './Admin.css';
import { triggerAPIRequest } from '../services/api.methods';

const Admin = () => {
  const [fighterName, setFighterName] = useState('');
  const [description, setDescription] = useState('');
  const [dwcsSeason, setDwcsSeason] = useState('');
  const [dwcsEpisode, setDwcsEpisode] = useState('');
  const [notification, setNotification] = useState({ message: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userInput = { full_name: fighterName, description };
      if (dwcsSeason && dwcsEpisode) {
        userInput.dwcs_info = `dwcs.s${dwcsSeason}e${dwcsEpisode}`;
      }

      const response = await triggerAPIRequest(
        'ufcaws', // endpoint
        'provider.aws', // category
        'sqs_enqueue', // action
        userInput, // updated userInput
        () => ({}) // getSettings returns empty object
      );
      console.log('API Response:', response);

      if (response.success) {
        // clear form
        setFighterName('');
        setDescription('');
        setDwcsSeason('');
        setDwcsEpisode('');
        setNotification({ message: 'Submission successful!', type: 'success' });
      } else {
        let errorMsg = response.message;
        if (typeof errorMsg === 'object' && errorMsg.result) {
          errorMsg = errorMsg.result;
        }
        setNotification({ message: errorMsg || 'Submission failed. Please try again.', type: 'error' });
      }
    } catch (error) {
      console.error('API Error:', error);
      setNotification({ message: 'Submission failed. Please try again.', type: 'error' });
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-content">
        <h1>Admin Panel</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fighterName">Fighter Full Name:</label>
            <textarea
              id="fighterName"
              value={fighterName}
              onChange={(e) => setFighterName(e.target.value)}
              rows="2"
              placeholder="Enter fighter's full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description:</label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="6"
              placeholder="Enter fighter's description"
            />
          </div>

          <div className="form-group">
            <label>DWCS (Optional):</label>
            <div className="dwcs-inputs">
              <input
                type="number"
                value={dwcsSeason}
                onChange={(e) => setDwcsSeason(e.target.value)}
                placeholder="Season"
                className="dwcs-input"
              />
              <input
                type="number"
                value={dwcsEpisode}
                onChange={(e) => setDwcsEpisode(e.target.value)}
                placeholder="Episode"
                className="dwcs-input"
              />
            </div>
          </div>

          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
        {notification.message && (
          <div className={`notification ${notification.type}`}>
            {notification.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default Admin; 